import { useEffect, useMemo, useState } from "react";
import { api } from "../api";
import { t } from "../i18n";
import { navigate } from "../utils/navigate";

export default function WallPage({ lang, guest }) {
  const [packs, setPacks] = useState([]);
  const [find, setFind] = useState("");
  const [err, setErr] = useState("");
  const [line, setLine] = useState("");

  useEffect(() => {
    let live = true;
    api(`/api/wall?lang=${encodeURIComponent(lang || "hi")}`)
      .then((d) => {
        if (!live) return;
        setPacks(d.wall || []);
        setLine(d.line || "");
      })
      .catch((e) => live && setErr(e.message));
    return () => {
      live = false;
    };
  }, [lang]);

  const shown = useMemo(() => {
    const q = find.toLowerCase().trim();
    if (!q) return packs;
    return packs.filter((p) =>
      `${p.salt} ${p.strength} ${(p.brands || []).join(" ")}`.toLowerCase().includes(q)
    );
  }, [packs, find]);

  return (
    <div className="tt-page">
      {guest && (
        <button className="tt-link" onClick={() => navigate("/")}>
          ← {t(lang, "familyLogin")}
        </button>
      )}
      <h2>{t(lang, "wall")}</h2>
      <p className="tt-muted">{t(lang, "wallHint")}</p>
      {err && <p className="tt-err">{err}</p>}
      <input
        placeholder={t(lang, "findPack")}
        value={find}
        onChange={(e) => setFind(e.target.value)}
        autoComplete="off"
      />
      {!shown.length && <p className="tt-muted">{t(lang, "wallEmpty")}</p>}
      {shown.map((p) => (
        <section key={`${p.salt}-${p.strength}`} className="tt-card tt-wall-pack">
          <h3>
            {p.salt} {p.strength}
          </h3>
          <p className="tt-muted">{(p.brands || []).join(" · ")}</p>
          {(p.effects || []).map((fx) => (
            <div
              key={fx.code}
              className={`tt-fx ${fx.seriousness === "emergency" || fx.seriousness === "call_doctor" ? "serious" : ""}`}
            >
              <div>
                <strong>{fx.name}</strong>
                <div className="tt-meta">
                  <span>{t(lang, fx.frequency === "very_common" ? "veryCommon" : fx.frequency === "uncommon" ? "uncommon" : fx.frequency === "rare" ? "rare" : "common")}</span>
                </div>
              </div>
              <span className="tt-chip">
                {fx.ticks} · {fx.families} {t(lang, "wallFamilies")}
              </span>
            </div>
          ))}
          {p.not_on_label?.ticks > 0 && (
            <p className="tt-muted">
              {t(lang, "notOnLabel")}: {p.not_on_label.ticks} · {p.not_on_label.families} {t(lang, "wallFamilies")}
            </p>
          )}
        </section>
      ))}
      <p className="tt-foot">{line || t(lang, "neverStop")}</p>
    </div>
  );
}
